module.exports = __webpack_public_path__ + "img/figure0-offer1.cce68bb1.png";